
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.402 31.9c.34.191.646.363.94.492V51.77h-6.47c-.55 0-1 .45-1 1s.45 1 1 1h14.94c.55 0 1-.45 1-1s-.45-1-1-1h-6.47V32.402a8.85 8.85 0 00.95-.502c.34-.2.73-.42 1.18-.63l.008-.004c.23-.11 5.393-2.603 6.572-6.536.576-1.911.745-3.916.51-6.142a1.01 1.01 0 00-.036-.315 25.205 25.205 0 00-.674-3.413c-.765-2.853-1.81-6.202-2.056-6.989l-.002-.007-.051-.164a.987.987 0 00-.95-.7h-12.92c-.43 0-.82.28-.95.7-.02.04-1.25 3.92-2.11 7.16-1.01 3.81-1.08 6.95-.2 9.87 1.2 4 6.53 6.52 6.58 6.54a11.86 11.86 0 01.729.363c.17.091.33.181.48.267zm10.063-13.95a23.653 23.653 0 00-.553-2.6c-.63-2.38-1.47-5.12-1.86-6.37h-11.43v.01c-.39 1.26-1.23 3.99-1.86 6.37a22.823 22.823 0 00-.61 3.04c2.905-.826 5.943-1.052 8.38-.59 4.59.87 6.899.493 7.933.14zm.189 2.036c-1.618.441-4.247.59-8.492-.216-2.33-.446-5.325-.158-8.144.75.007 1.28.183 2.474.524 3.62.72 2.41 4.02 4.61 5.5 5.3.51.24.95.49 1.34.7l.077.043c.343.19.735.408.883.427.16-.01.62-.27.96-.47.38-.22.82-.47 1.33-.71 1.48-.69 4.78-2.89 5.5-5.3.393-1.3.567-2.664.522-4.144z"}})])
          )
        }
      }
    